export default __webpack_public_path__ + "static/media/sport-bg.1301c64e.webp";